import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import VoiceHost from './pages/VoiceHost';
import GameGuide from './pages/GameGuide';
import GameProgress from './pages/GameProgress';
import GameNotes from './pages/GameNotes';
import SpeechTimer from './pages/SpeechTimer';
import GameStats from './pages/GameStats';
import PlayerDetail from './pages/PlayerDetail';
import { Login } from './pages/Login';
import ProfilePage from './pages/ProfilePage';
import TestPage from './pages/OfflineGamePage';
import OnlineLobbyPage from './pages/OnlineLobby';
import OnlineGameRoom from './pages/OnlineGameRoom';
import GamePlay from './pages/GamePlay';
import GameEnd from './pages/GameEnd';
import GameDateDiagnose from './pages/GameDateDiagnose';
import BottomNav from './components/BottomNav';
import { SilentRefreshService } from './services/SilentRefreshService';
import { useEffect } from 'react';

// V527: 初始化后台静默刷新服务
SilentRefreshService.getInstance().start();

export default function App() {
  // V527: 页面可见性变化时控制静默刷新
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('[V527] 页面隐藏，暂停静默刷新');
      } else {
        console.log('[V527] 页面可见，恢复静默刷新');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const location = useLocation();
  // 在线上游戏房间页面隐藏底部导航和全局 padding
  const isOnlineRoom = location.pathname.startsWith('/online/room');

  return (
    <div className={`min-h-screen ${!isOnlineRoom ? 'pb-[60px]' : ''}`}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/online-lobby" element={<OnlineLobbyPage />} />
        <Route path="/online/room/:roomId" element={<OnlineGameRoom />} />
        <Route path="/game/play" element={<GamePlay />} />
        <Route path="/game/end" element={<GameEnd />} />
        <Route path="/host" element={<VoiceHost />} />
        <Route path="/guide" element={<GameGuide />} />
        <Route path="/progress" element={<GameProgress />} />
        <Route path="/offline-game" element={<TestPage />} />
        <Route path="/vote" element={<GameNotes />} />
        <Route path="/timer" element={<SpeechTimer />} />
        <Route path="/stats" element={<GameStats />} />
        <Route path="/player-detail" element={<PlayerDetail />} />
        <Route path="/player/:playerNumber" element={<PlayerDetail />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/diagnose" element={<GameDateDiagnose />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {!isOnlineRoom && <BottomNav />}
    </div>
  );
}
